import { MapCreator } from '../../../../utils/map-creator';
import { DestinationSubDocument } from '../destination/sub-document/destination-sub-document';
export const addParagraphPropertiesKeywords = new MapCreator()
    .add("brdrt", DestinationSubDocument.onTopParagraphBorderKeyword)
    .add("brdrb", DestinationSubDocument.onBottomParagraphBorderKeyword)
    .add("brdrl", DestinationSubDocument.onLeftParagraphBorderKeyword)
    .add("brdrr", DestinationSubDocument.onRightParagraphBorderKeyword)
    .add("brdrbtw", DestinationSubDocument.onBetweenParagraphBorderKeyword)
    .add("brdrbar", DestinationSubDocument.onBarParagraphBorderKeyword)
    .add("posx", DestinationSubDocument.onFrameHorizontalPositionKeyword)
    .add("posnegx", DestinationSubDocument.onFrameHorizontalPositionNegativeKeyword)
    .add("posxc", DestinationSubDocument.onFrameHorizontalAlignmentCenterKeyword)
    .add("posxi", DestinationSubDocument.onFrameHorizontalAlignmentInsideKeyword)
    .add("posxo", DestinationSubDocument.onFrameHorizontalAlignmentOutsideKeyword)
    .add("posxr", DestinationSubDocument.onFrameHorizontalAlignmentRightKeyword)
    .add("posxl", DestinationSubDocument.onFrameHorizontalAlignmentLeftKeyword)
    .add("posy", DestinationSubDocument.onFrameVerticalPositionKeyword)
    .add("posnegy", DestinationSubDocument.onFrameVerticalPositionNegativeKeyword)
    .add("posyil", DestinationSubDocument.onFrameVerticalAlignmentInlineKeyword)
    .add("posyt", DestinationSubDocument.onFrameVerticalAlignmentTopKeyword)
    .add("posyc", DestinationSubDocument.onFrameVerticalAlignmentCenterKeyword)
    .add("posyb", DestinationSubDocument.onFrameVerticalAlignmentBottomKeyword)
    .add("posyin", DestinationSubDocument.onFrameVerticalAlignmentInsideKeyword)
    .add("posyout", DestinationSubDocument.onFrameVerticalAlignmentOutsideKeyword)
    .add("absw", DestinationSubDocument.onFrameWidthKeyword)
    .add("absh", DestinationSubDocument.onFrameHeightKeyword)
    .add("dxfrtext", DestinationSubDocument.onFramePaddingKeyword)
    .add("dfrmtxty", DestinationSubDocument.onFrameVerticalPaddingKeyword)
    .add("dfrmtxtx", DestinationSubDocument.onFrameHorizontalPaddingKeyword)
    .add("phmrg", DestinationSubDocument.onParagraphHorizontalPositionTypeMarginKeyword)
    .add("phpg", DestinationSubDocument.onParagraphHorizontalPositionTypePageKeyword)
    .add("phcol", DestinationSubDocument.onParagraphHorizontalPositionTypeColumnKeyword)
    .add("pvmrg", DestinationSubDocument.onParagraphVerticalPositionTypeMarginKeyword)
    .add("pvpg", DestinationSubDocument.onParagraphVerticalPositionTypePageKeyword)
    .add("pvpara", DestinationSubDocument.onParagraphVerticalPositionTypeLineKeyword)
    .add("nowrap", DestinationSubDocument.onFrameNoWrapKeyword)
    .add("overlay", DestinationSubDocument.onFrameWrapOverlayKeyword)
    .add("wrapdefault", DestinationSubDocument.onFrameWrapDefaultKeyword)
    .add("wraparound", DestinationSubDocument.onFrameWrapAroundKeyword)
    .add("wraptight", DestinationSubDocument.onFrameWrapTightKeyword)
    .add("wrapthrough", DestinationSubDocument.onFrameWrapThroughKeyword)
    .add("abslock", DestinationSubDocument.onFrameLockAnchor)
    .add("ql", DestinationSubDocument.onAlignLeftKeyword)
    .add("qc", DestinationSubDocument.onAlignCenterKeyword)
    .add("qr", DestinationSubDocument.onAlignRightKeyword)
    .add("qd", DestinationSubDocument.onAlignJustifyKeyword)
    .add("qj", DestinationSubDocument.onAlignJustifyKeyword)
    .add("li", DestinationSubDocument.onLeftIndentKeyword)
    .add("lin", DestinationSubDocument.onLeftIndentKeyword)
    .add("ri", DestinationSubDocument.onRightIndentKeyword)
    .add("fi", DestinationSubDocument.onFirstLineIndentKeyword)
    .add("rin", DestinationSubDocument.onRightIndentKeyword)
    .add("sb", DestinationSubDocument.onSpacingBeforeKeyword)
    .add("sa", DestinationSubDocument.onSpacingAfterKeyword)
    .add("sl", DestinationSubDocument.onLineSpacingTypeKeyword)
    .add("slmult", DestinationSubDocument.onLineSpacingMultiplierKeyword)
    .add("hyphpar", DestinationSubDocument.onHyphenateParagraphKeyword)
    .add("noline", DestinationSubDocument.onSuppressLineNumbersKeyword)
    .add("contextualspace", DestinationSubDocument.onContextualSpacingKeyword)
    .add("pagebb", DestinationSubDocument.onPageBreakBeforeKeyword)
    .add("sbauto", DestinationSubDocument.onBeforeAutoSpacingKeyword)
    .add("saauto", DestinationSubDocument.onAfterAutoSpacingKeyword)
    .add("keepn", DestinationSubDocument.onKeepWithNextKeyword)
    .add("keep", DestinationSubDocument.onKeepLinesTogetherKeyword)
    .add("widctlpar", DestinationSubDocument.onWidowOrphanControlOnKeyword)
    .add("nowidctlpar", DestinationSubDocument.onWidowOrphanControlOffKeyword)
    .add("outlinelevel", DestinationSubDocument.onOutlineLevelKeyword)
    .add("shading", DestinationSubDocument.onParagraphShadingKeyword)
    .add("bghoriz", DestinationSubDocument.onParagraphHorizontalBackgroundPatternKeyword)
    .add("bgvert", DestinationSubDocument.onParagraphVerticalBackgroundPatternKeyword)
    .add("bgfdiag", DestinationSubDocument.onParagraphForwardDiagonalBackgroundPatternKeyword)
    .add("bgbdiag", DestinationSubDocument.onParagraphBackwardDiagonalBackgroundPatternKeyword)
    .add("bgcross", DestinationSubDocument.onParagraphCrossBackgroundPatternKeyword)
    .add("bgdcross", DestinationSubDocument.onParagraphDiagonalCrossBackgroundPatternKeyword)
    .add("bgdkhoriz", DestinationSubDocument.onParagraphDarkHorizontalBackgroundPatternKeyword)
    .add("bgdkvert", DestinationSubDocument.onParagraphDarkVerticalBackgroundPatternKeyword)
    .add("bgdkfdiag", DestinationSubDocument.onParagraphDarkForwardDiagonalBackgroundPatternKeyword)
    .add("bgdkbdiag", DestinationSubDocument.onParagraphDarkBackwardDiagonalBackgroundPatternKeyword)
    .add("bgdkcross", DestinationSubDocument.onParagraphDarkCrossBackgroundPatternKeyword)
    .add("bgdkdcross", DestinationSubDocument.onParagraphDarkDiagonalCrossBackgroundPatternKeyword)
    .add("cfpat", DestinationSubDocument.onParagraphFillColorKeyword)
    .add("cbpat", DestinationSubDocument.onParagraphBackgroundKeyword)
    .get();
